import { IllustrationRequest } from '../../../IllustrationRequest';
import { RiderType } from '../../../../../../common/js/static/Product';

export class IllustrationSummary {
  static getSummary(illustrationRequest: IllustrationRequest): string {
    let summary = IllustrationHtml.summary
      .replace(/{{Waiver}}/, this.getWaiverOfPremiumRow(illustrationRequest.waiverUnits > 0))
      .replace(/{{FlatExtra}}/, this.getFlatExtraRow(illustrationRequest.flatExtra > 0))
      .replace(/{{PremiumTotals}}/, this.getPremiumTotals(illustrationRequest.waiverUnits > 0));

    let show1035Summary = false;
    if (illustrationRequest.cashValueTransfer > 0) {
      show1035Summary = true;
      if (illustrationRequest.transferAmount > 0) {
        show1035Summary = true;
      } else if (illustrationRequest.transferAmount <= 0) {
        show1035Summary = false;
      }
    }
    summary = summary.replace(/{{CashValueTransferTotals}}/, this.getCashValueTransferTotals(show1035Summary));

    if (illustrationRequest.riders) {
      summary = summary
        .replace(
          /{{GirTotals}}/,
          this.getGirTotals(illustrationRequest.riders.filter((rider) => rider.type === RiderType.GIR).length > 0)
        )
        .replace(
          /{{RtrTotals}}/,
          this.getRtrTotals(illustrationRequest.riders.filter((rider) => rider.type === RiderType.RTR).length > 0)
        )
        .replace(
          /{{AlirTotals}}/,
          this.getAlirTotals(illustrationRequest.riders.filter((rider) => rider.type === RiderType.ALIR).length > 0)
        )
        .replace(
          /{{CirTotals}}/,
          this.getCirTotals(illustrationRequest.riders.filter((rider) => rider.type === RiderType.CIR).length > 0)
        )
        .replace(
          /{{GirWaiverTotals}}/,
          this.getGirWaiverTotals(
            illustrationRequest.riders.filter((rider) => rider.type === RiderType.GIR).length > 0 &&
              illustrationRequest.waiverUnits > 0
          )
        )
        .replace(
          /{{RtrWaiverTotals}}/,
          this.getRtrWaiverTotals(
            illustrationRequest.riders.filter((rider) => rider.type === RiderType.RTR).length > 0 &&
              illustrationRequest.waiverUnits > 0
          )
        )
        .replace(
          /{{CirWaiverTotals}}/,
          this.getCirWaiverTotals(
            illustrationRequest.riders.filter((rider) => rider.type === RiderType.CIR).length > 0 &&
              illustrationRequest.waiverUnits > 0
          )
        );
    }
    return summary;
  }

  static getStyles() {
    return `${IllustrationHtml.style}`;
  }

  static getWaiverOfPremiumRow(hasWOP: boolean) {
    return hasWOP
      ? `<TR>
            <TD><P class="p-left">Waiver</P></TD>
            <TD class="align-right"><P>{{FaceAmount}}</P></TD>
            <TD class="align-right"><P>{{WaiverAnnual}}</P></TD>
            <TD class="align-right"><P>{{WaiverMonthly}}</P></TD>
            </TR>`
      : '';
  }

  static getFlatExtraRow(hasFlatExtra: boolean) {
    return hasFlatExtra
      ? `<TR>
            <TD><P class="p-left left-indent">Perm Flat Extra</P></TD>
            <TD class="align-right"></TD>
            <TD class="align-right"><P>{{FlatExtraAnnual}}</P></TD>
            <TD class="align-right"><P>{{FlatExtraMonthly}}</P></TD>
            </TR>`
      : '';
  }

  static getGirTotals(hasGir: boolean) {
    return hasGir
      ? `<TR>
            <TD><P class="p-left">Guaranteed Insurability Rider</P></TD>
            <TD class="align-right"><P>{{GirFaceAmount}}</P></TD>
            <TD class="align-right"><P>{{GirAnnual}}</P></TD>
            <TD class="align-right"><P>{{GirMonthly}}</P></TD>
            </TR>`
      : '';
  }

  static getRtrTotals(hasRtr: boolean) {
    return hasRtr
      ? `<TR>
            <TD><P class="p-left">Renewable Term Rider</P></TD>
            <TD class="align-right"><P>{{RtrFaceAmount}}</P></TD>
            <TD class="align-right"><P>{{RtrAnnual}}</P></TD>
            <TD class="align-right"><P>{{RtrMonthly}}</P></TD>
            </TR>`
      : '';
  }

  static getAlirTotals(hasAlir: boolean) {
    return hasAlir
      ? `<TR>
            <TD><P class="p-left">Scheduled ALIR (Year 1)</P></TD>
            <TD class="align-right"><P>N/A</P></TD>
            <TD class="align-right"><P>{{AlirAnnual}}</P></TD>
            <TD class="align-right"><P>{{AlirMonthly}}</P></TD>
            </TR>`
      : '';
  }

  static getCirTotals(hasCir: boolean) {
    return hasCir
      ? `<TR>
            <TD><P class="p-left">CIR Base Benefit Pool</P></TD>
            <TD class="align-right"><P>{{CirBaseBenefitPool}}</P></TD>
            <TD class="align-right"><P>{{CirAnnual}}</P></TD>
            <TD class="align-right"><P>{{CirMonthly}}</P></TD>
            </TR>`
      : '';
  }

  static getGirWaiverTotals(hasGirWaiver: boolean) {
    return hasGirWaiver
      ? `<TR>
            <TD><P class="p-left">Guaranteed Insurability Waiver</P></TD>
            <TD class="align-right"><P>{{GirFaceAmount}}</P></TD>
            <TD class="align-right"><P>{{GirWaiverAnnual}}</P></TD>
            <TD class="align-right"><P>{{GirWaiverMonthly}}</P></TD>
            </TR>`
      : '';
  }

  static getRtrWaiverTotals(hasRtrWaiver: boolean) {
    return hasRtrWaiver
      ? `<TR>
            <TD><P class="p-left">Renewable Term Waiver</P></TD>
            <TD class="align-right"><P>{{RtrFaceAmount}}</P></TD>
            <TD class="align-right"><P>{{RtrWaiverAnnual}}</P></TD>
            <TD class="align-right"><P>{{RtrWaiverMonthly}}</P></TD>
            </TR>`
      : '';
  }

  static getCirWaiverTotals(hasGirWaiver: boolean) {
    return hasGirWaiver
      ? `<TR>
            <TD><P class="p-left">CIR Waiver</P></TD>
            <TD class="align-right"><P>{{CirBaseBenefitPool}}</P></TD>
            <TD class="align-right"><P>{{CirWaiverAnnual}}</P></TD>
            <TD class="align-right"><P>{{CirWaiverMonthly}}</P></TD>
            </TR>`
      : '';
  }

  static getPremiumTotals(hasWOP: boolean) {
    return hasWOP
      ? `<TR>
            <TD><P class="p-left">Total Initial Modal Premium</P></TD>
            <TD class="align-right"></TD>
            <TD class="align-right"><P>{{ModalPremiumAnnual}}</P></TD>
            <TD class="align-right"><P>{{ModalPremiumMonthly}}</P></TD>
        </TR>`
      : '';
  }

  static getPagesFromRows(totalRows: number, rowsOnFirstPage: number, rowsOnOtherPages: number): number {
    return 1 + Math.ceil((totalRows - rowsOnFirstPage) / rowsOnOtherPages);
  }

  static getCashValueTransferTotals(hasCashValueTransfer: boolean) {
    return hasCashValueTransfer
      ? `<TR>
            <TD><P class="p-left">Unscheduled ALIR (Year 1)</P></TD>
              <TD class="align-right"><P>N/A</P></TD>
              <TD class="align-right"><P>{{CashValueTransferAmount}}</P></TD>
              <TD class="align-right"><P>{{CashValueTransferAmount}}</P></TD>
            </TR>`
      : '';
  }
}
export const IllustrationHtml = {
  summary: `<DIV id="page_7" class="full-width">
        <TABLE id="illus-summary-table" class="td-underline" cellspacing="0" cellpadding="0">
        <TR>
            <TD colspan="2"></TD>
            <TD colspan="2" class="td-underline"><P class="p-center">Current Premiums</P></TD>
        </TR>
        <TR class="p-underline">
            <TD><P class="p-left p-underline">Coverage</P></TD>
            <TD class="align-right"><P class="p-underline">Face Amount</P></TD>
            <TD class="align-right"><P class="p-underline">Annually</P></TD>
            <TD class="align-right"><P class="p-underline">Monthly</P></TD>
        </TR>
        <TR>
            <TD><P class="p-left">Base Policy Insurance</P></TD>
            <TD class="align-right"><P>{{FaceAmount}}</P></TD>
            <TD class="align-right"><P>{{BasePremiumAnnual}}</P></TD>
            <TD class="align-right"><P>{{BasePremiumMonthly}}</P></TD>
        </TR>
        {{FlatExtra}}
        {{GirTotals}}
        {{RtrTotals}}
        {{AlirTotals}}
        {{CirTotals}}
        {{Waiver}}
        {{GirWaiverTotals}}
        {{RtrWaiverTotals}}
        {{CirWaiverTotals}}
        {{PremiumTotals}}

        <TR>
            <TD><P class="p-left">Total Initial Modal Premium (Annualized)</P></TD>
            <TD class="align-right"></TD>
            <TD class="align-right"><P>{{ModalAnnualizedPremiumAnnual}}</P></TD>
            <TD class="align-right"><P>{{ModalAnnualizedPremiumMonthly}}</P></TD>
        </TR>
      
        {{CashValueTransferTotals}}
        </TABLE>
        </DIV>`,
  style: `
        #page_7 {position:relative; overflow: hidden;padding: 0px;border: none;}

        #illus-summary-table {width : 100%; border-collapse: collapse;}
        #illus-summary-table tr td, #illus-summary-table tr td p {font: 8px 'Times New Roman';white-space: nowrap;line-height: 11px;}

        #illustration-table {width : 100%; cellspacing:0; cellpadding: 0; border-collapse:collapse; }
        #illustration-table tr td p {font: 8px 'Times New Roman';text-align: right;padding: 0px;margin: 0px;white-space: nowrap;line-height: 10px;}
        #illustration-table tr th, #illustration-table tr th p {font: 8px 'Times New Roman';white-space: nowrap;line-height: 8px;}

        .ft-space-underline{font: 0px 'Times New Roman';line-height: 0px;border-bottom: #000000 1px solid;}
        .td-underline{border-bottom: #000000 1px solid;padding: 0px;margin: 0px;vertical-align: bottom;}
        .p-underline{text-decoration: underline; padding: 0px;margin: 0px;vertical-align: bottom;}
        .dclr {clear:both;float:none;height:1px;margin:0px;padding:0px;overflow:hidden;}
        .odd-row{background: #ebebeb;}
        .footer-text{font: 9px 'Times New Roman';}
        .footer-text-bold{font:bold 9px 'Times New Roman';line-height: 9px;}
        .td-sideline{border-right: #000000 1px solid;padding: 0px;margin: 0px;vertical-align: bottom;}

        .align-right {text-align:right}`,
  title: 'Tabular Values',
  supplementalTitle: 'Supplemental Values',
  cirClaimIllustrationTitle: 'Impact of CIR on Policy Values',
};
